import { RolloverUploadErrorItem } from '../../../apis/rolloverUpload';
import { RowErrorGroup } from '../types';

export const groupErrorsByRow = (
  errors: RolloverUploadErrorItem[]
): RowErrorGroup[] => {
  const map: Record<number, RolloverUploadErrorItem[]> = {};
  errors.forEach((err) => {
    if (!map[err.rowNumber]) map[err.rowNumber] = [];
    map[err.rowNumber].push(err);
  });
  return Object.keys(map)
    .sort((a, b) => Number(a) - Number(b))
    .map((row) => {
      const rowErrors = map[Number(row)];
      const uniqueKeys = Array.from(new Set(rowErrors.map((e) => e.key)));
      const studentEmail = rowErrors[0]?.studentEmail;
      return {
        rowNumber: Number(row),
        errors: rowErrors,
        fieldKeys: uniqueKeys.join('\n'),
        messages: rowErrors.map((e) => `${e.key}: ${e.message}`).join('\n'),
        errorCount: rowErrors.length,
        studentEmail
      } as RowErrorGroup;
    });
};
